// src/types/UserState.ts

import type { FieldErrors } from '@/types/AuthState';
import type { NotificationActionType } from '@/types/NotificationDTOs';
import type { Pagination } from '@/types/Sixes';

const COUNT = 0;

/**
 * Actor who performed the notification action (FE model)
 */
export interface NotificationActor {
  id: string;
  name: string;
}

/**
 * SIX context for notification (FE model)
 */
export interface NotificationSix {
  id: string;
  name: string;
}

/**
 * Individual notification item (FE model)
 */
export interface NotificationItem {
  id: string;
  type: NotificationActionType;
  actor: NotificationActor;
  six: NotificationSix;
  action: string;
  target?: string;
  read: boolean;
  createdAt: Date;
}

/**
 * Notifications state (FE model)
 */
export interface Notifications {
  items: NotificationItem[];
  unreadCount: number;
  pagination?: Pagination;
}

/**
 * User profile (FE model)
 */
export interface User {
  id: string;
  name: string;
  phone: string;
  department?: string;
  email?: string;
  organization: string;
}

/**
 * User state for Redux
 */
export interface UserState {
  user: User | null;
  fieldErrors: FieldErrors;
  loadingUser: boolean;
  loadingNotifications: boolean;
  notifications: Notifications;
}

export const initialUserState: UserState = {
  user: null,
  fieldErrors: {},
  loadingUser: false,
  loadingNotifications: false,
  notifications: {
    items: [],
    unreadCount: COUNT,
    pagination: undefined,
  },
};
